var id = 0
  , px = Math.random();
module.exports = function(key){
  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
};


//////////////////
// WEBPACK FOOTER
// ./~/redux-api-middleware/~/core-js/library/modules/$.uid.js
// module id = 467
// module chunks = 0